export default {
  SET_CONSULT({ commit }, payload) {
    commit('SET_CONSULT', payload);
  },

  SET_DOCUMENTS_CONSULTED({ commit }, payload) {
    commit('SET_DOCUMENTS_CONSULTED', payload);
  },

  SET_QUOTA({ commit }, payload) {
    commit('SET_QUOTA', payload);
  },
};
